import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 flex items-center justify-between h-16 md:h-[72px]">
        <a href="#top" className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap">
          <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-sun-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-semibold tracking-wide text-foreground-950">
              长日光阴
            </span>
            <span className="text-[10px] tracking-[0.25em] font-label text-foreground-500">
              MEMOIR
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3 py-2 text-sm rounded-md transition-colors cursor-pointer whitespace-nowrap text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm whitespace-nowrap transition-colors cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600"
          >
            <i className="ri-mail-open-line"></i>
            订阅回忆录
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900"
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-1 px-3 py-2.5 rounded-md text-sm bg-primary-500 text-background-50 text-center cursor-pointer"
          >
            订阅回忆录
          </a>
        </div>
      )}
    </header>
  );
}